function initDynamicGridPattern() {
  console.log('Initializing dynamic grid pattern for 2024 collection');

  const gridContainer = document.querySelector('#ProductGridContainer2024');
  if (!gridContainer) return;

  const gridPattern = gridContainer.getAttribute('data-grid-pattern');
  if (!gridPattern) return;

  // Parse the pattern (e.g., "1-2-2-1-2" -> [1, 2, 2, 1, 2])
  const pattern = gridPattern.split('-').map(num => parseInt(num, 10));
  if (pattern.length === 0 || pattern.some(isNaN)) return;

  // Calculate the total products in one pattern cycle
  const patternLength = pattern.reduce((sum, num) => sum + num, 0);

  // Generate unique class name for this specific pattern
  console.log(`Using grid pattern: ${gridPattern}`);
  console.log(`Pattern array:`, pattern);
  console.log(`Pattern length: ${patternLength}`);
  const patternClass = `grid-pattern-${gridPattern.replace(/-/g, '')}`;
  
  // Add the pattern class to the grid container
  gridContainer.classList.add(patternClass);

  // Generate CSS for desktop view
  let css = `
    @media screen and (min-width: 750px) {
      .${patternClass}.desktop-view-2__2024 .product-grid {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        gap: 20px;
      }
  `;

  // Generate CSS for each row in the pattern
  let productIndex = 0;
  let cssRules = [];
  
  pattern.forEach((productsInRow, rowIndex) => {
    // Calculate column span for this row
    const colSpan = Math.floor(12 / productsInRow);
    
    // Track the starting column for proper alignment
    let startCol = 1;
    
    for (let i = 0; i < productsInRow; i++) {
      productIndex++;
      const nthChild = productIndex;
      
      // For single items, center them by using half the grid
      if (productsInRow === 1) {
        cssRules.push(`
      .${patternClass}.desktop-view-2__2024 .grid__item:nth-child(${patternLength}n+${nthChild}) {
        grid-column: 4 / span 6;
        grid-row: var(--grid-row, auto);
      }
      .${patternClass}.desktop-view-2__2024 .grid__item.panoramic-banner:nth-child(${patternLength}n+${nthChild}) {
        grid-column: 1 / -1;
        grid-row: var(--grid-row, auto);
      }`);
      } else {
        // For rows with multiple items, explicitly place each item
        const endCol = startCol + colSpan;
        cssRules.push(`
      .${patternClass}.desktop-view-2__2024 .grid__item:nth-child(${patternLength}n+${nthChild}) {
        grid-column: ${startCol} / ${endCol};
        grid-row: var(--grid-row, auto);
      }`);
        startCol = endCol;
      }
    }
  });
  
  css += cssRules.join('');

  // Add 2-column layout for tablets
  css += `
    }
    
    @media screen and (min-width: 750px) and (max-width: 990px) {
      .${patternClass}.desktop-view-2__2024 .product-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }
      
      .${patternClass}.desktop-view-2__2024 .grid__item {
        grid-column: span 1 !important;
      }
    }
    
    /* Simple layout for 2 or fewer products */
    @media screen and (min-width: 750px) {
      .${patternClass}.simple-layout.desktop-view-2__2024 .product-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }
      
      .${patternClass}.simple-layout.desktop-view-2__2024 .grid__item {
        grid-column: auto !important;
        grid-row: auto !important;
      }
    }
    
  `;

  // Create and inject the style element
  const styleId = `dynamic-grid-pattern-${gridPattern}`;
  let styleElement = document.getElementById(styleId);
  
  if (!styleElement) {
    styleElement = document.createElement('style');
    styleElement.id = styleId;
    document.head.appendChild(styleElement);
  }
  
  styleElement.textContent = css;

  // Assign correct grid row numbers to all items
  const assignGridRows = () => {
    const productGrid = gridContainer.querySelector('.product-grid');
    if (!productGrid) return;
    
    const gridItems = productGrid.querySelectorAll('.grid__item');
    let currentRow = 1;
    let currentRowPosition = 0;
    let patternIndex = 0;
    
    gridItems.forEach((item) => {
      // Get how many products should be in this row based on pattern
      const productsInThisRow = pattern[patternIndex];
      
      // If we've filled the current row, move to next row
      if (currentRowPosition >= productsInThisRow) {
        currentRow++;
        currentRowPosition = 0;
        patternIndex = (patternIndex + 1) % pattern.length;
      }
      
      // Set the CSS custom property for this item
      item.style.setProperty('--grid-row', currentRow);
      currentRowPosition++;
    });
  };

  // Update remainder class when products change (for infinite scroll)
  const updateRemainderClass = () => {
    const productGrid = gridContainer.querySelector('.product-grid');
    if (!productGrid) return;
    
    const currentProducts = productGrid.querySelectorAll('.grid__item').length;
    const remainder = currentProducts % patternLength;
    
    // Remove old remainder classes
    for (let i = 0; i < patternLength; i++) {
      productGrid.classList.remove(`remainder-${i}`);
    }
    
    // Add new remainder class
    productGrid.classList.add(`remainder-${remainder}`);
    
    // For 2 or fewer products, use simple side-by-side layout instead of pattern
    if (currentProducts <= 2) {
      gridContainer.classList.add('simple-layout');
    } else {
      gridContainer.classList.remove('simple-layout');
    }
    
    // Assign correct grid rows to all items
    assignGridRows();
  };

  // Initial update
  updateRemainderClass();

  // Update on infinite scroll
  document.addEventListener('collection:infinitescroll', updateRemainderClass);
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDynamicGridPattern);
} else {
  initDynamicGridPattern();
}

// Reinitialize in Shopify theme editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initDynamicGridPattern);
}